import path from "path";

const jpegExts = ['.JPEG', '.JPG'];
const pngExts = ['.PNG'];
const pdfExts = ['.PDF'];
const imageExts = jpegExts.concat(pngExts);


export const isSvg = function(fileName) {
    return path.extname(fileName).toUpperCase() === '.SVG';
};

export const isPdf = function(fileName) {
    return path.extname(fileName).toUpperCase() === '.PDF';
};

export const isThreeD = function(fileName) {
    return path.extname(fileName).toUpperCase() === '.GLB';
};

export const isImage = function(fileName) {
    return imageExts.includes(path.extname(fileName).toUpperCase());
};

export const isBinaryFile = function(filename) {
    if (isSvg(filename) || isPdf(filename))
        return false;
    return true;
}

export const FS_PLANS_FOLDER_NAME = "Plans";
export const FS_MODELS_FOLDER_NAME = "Models";
export const FS_PANOS_FOLDER_NAME = "Panos";
export const FS_PCLS_FOLDER_NAME = "PCLs";


export const DocumentType = {};

Object.defineProperties(DocumentType, {
    UNKNOWN : { value: -1, writable:false },
    SVG : { value: 0, writable:false },
    JPEG : { value: 1, writable:false },
    PDF : { value: 2, writable:false },
});

export const MIME_JPG = "image/jpg";
export const MIME_JPEG = "image/jpeg";
export const MIME_SVG = "image/svg+xml";
export const MIME_PDF = "application/pdf";

export const isSvgType = function(type) {
    return [MIME_SVG].includes(type.toLowerCase());
};

export const isPdfType = function(type) {
    return [MIME_PDF].includes(type.toLowerCase());
};

export const isJpegType = function(type) {
    return [MIME_JPG, MIME_JPEG].includes(type.toLowerCase());
};

export const documentType = function(type) {
    if (isSvgType(type)) return DocumentType.SVG;
    if (isJpegType(type)) return DocumentType.JPEG;
    if (isPdfType(type)) return DocumentType.PDF;
    return DocumentType.UNKNOWN;
}

export const getPersistentData = (key, initialValue = '') => {
    try {
        const item = window.localStorage.getItem(key);
        return item ? JSON.parse(item) : initialValue;
    } catch (error) {
        return initialValue;
    }
}


export const persistData = (key, value) => {
    try {
        window.localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
    }
};